module.exports = __webpack_public_path__ + "img/image7.7f020eb1.png";